// @flow
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import generateFAQsSeoSchema from 'utils/seo/generateFAQsSeoSchema';
import Accordion from './Accordion';
import styles from './FAQs.scss';

/**
 * Render React Template
 * @param {Object} props component props
 * @returns {JSX} markup
 */
export const FAQs = (props: any) => {
  const { FaqContentCol1, FaqContentCol2, onClickHandler } = props;

  // added to set schema data for SEO
  const seoSchemaObject = FaqContentCol2
    ? FaqContentCol1.concat(FaqContentCol2)
    : FaqContentCol1;
  const seoSchema = generateFAQsSeoSchema(seoSchemaObject);

  return (
    <Fragment>
      <div className={styles.FAQMainConatiner}>
        {seoSchema && <Helmet script={[seoSchema]} />}
        <h2 className={styles.FAQsHeading}>FAQs</h2>
        <div className={styles.FAQContainer}>
          {FaqContentCol1 && (
            <div
              className={FaqContentCol2 ? styles.FAQCol1 : styles.FAQSingleCol}
            >
              {FaqContentCol1.map((item, index) => (
                <div
                  onClick={() => {
                    onClickHandler && onClickHandler(item);
                  }}
                  key={index}
                  className={styles.FAQ}
                >
                  <Accordion content={[item]} isHtml />
                </div>
              ))}
            </div>
          )}

          {FaqContentCol2 && (
            <div className={styles.FAQCol2}>
              {FaqContentCol2.map((item, index) => (
                <div
                  onClick={() => {
                    onClickHandler && onClickHandler(item);
                  }}
                  key={index}
                  className={styles.FAQ}
                >
                  <Accordion content={[item]} isHtml />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

FAQs.propTypes = {
  FaqContentCol1: PropTypes.array.isRequired,
  FaqContentCol2: PropTypes.array,
  onClickHandler: PropTypes.func
};

export default FAQs;



// WEBPACK FOOTER //
// ./src/components/FAQs/FAQs.js